module.exports = __webpack_public_path__ + "assets/infographic-icon-3.1ead7e17.svg";